export default "__VITE_ASSET__BKzpUNAi__"